import { AppRequestDto } from '../dtos/app-request.dto';
import { AppRequestModel } from '../models/app-request.model';

export function mapAppRequestDtoToAppRequestModel({
  id,
  categoriesIds,
  countriesRegionsIds,
  defaultLanguageIso,
  iconId,
  longDescription,
  name,
  privacyPolicy,
  publisherName,
  screenshotsIds,
  shortDescription,
  website,
  isFeatured,
  packageName,
}: AppRequestDto): AppRequestModel {
  return {
    id,
    categoriesIds,
    countriesRegionsIds,
    defaultLanguageIso,
    iconId,
    longDescription,
    name,
    privacyPolicy,
    publisherName,
    screenshotsIds,
    shortDescription,
    website,
    isFeatured,
    packageName,
  };
}

export function mapAppRequestModelToAppRequestDto({
  id,
  categoriesIds,
  countriesRegionsIds,
  defaultLanguageIso,
  iconId,
  longDescription,
  name,
  privacyPolicy,
  publisherName,
  screenshotsIds,
  shortDescription,
  website,
  isFeatured,
  packageName,
}: AppRequestModel): AppRequestDto {
  return {
    id,
    categoriesIds,
    countriesRegionsIds,
    defaultLanguageIso,
    iconId,
    longDescription,
    name,
    privacyPolicy,
    publisherName,
    screenshotsIds,
    shortDescription,
    website,
    isFeatured,
    packageName,
  };
}
